/*!
=========================================================
* Muse Ant Design Dashboard - v1.0.0
=========================================================
* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React from "react";

import { Provider } from "react-redux";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import useAuth from "hooks/useAuth";
import { store } from "store/store";
import { BotForm, BotList } from "pages/bot";
import { PlatformForm, PlatformList } from "pages/platform";

import Main from "./components/layout/Main";

import "antd/dist/antd.min.css";

import "./assets/styles/main.css";
import "./assets/styles/responsive.css";

const Content: React.FC = () => {
  const { user } = useAuth();

  return (
    user && (
      <Routes>
        <Route path="/" element={<Main />}>
          <Route path="bot">
            <Route path="list" element={<BotList />} />
            <Route path="create" element={<BotForm />} />
            <Route path="edit/:code" element={<BotForm />} />
          </Route>
          <Route path="platform">
            <Route path="list" element={<PlatformList />} />
            <Route path="create" element={<PlatformForm />} />
            <Route path="edit/:code" element={<PlatformForm />} />
          </Route>
        </Route>
      </Routes>
    )
  );
};

const AppRoute = () => {
  return (
    <div className="App">
      {
        <Provider store={store}>
          <Router>
            <Content />
          </Router>
        </Provider>
      }
    </div>
  );
};

export default AppRoute;
